module.exports = __webpack_public_path__ + "img/welcome-org.801c0af5.png";